module.exports = __webpack_public_path__ + "img/building.2bb3c1f4.png";